export default (function (value) {
  return value == null;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/yup/es/util/isAbsent.js
// module id = 372
// module chunks = 11